import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./MembershipPage.css";
import {
  Container,
  InputCheckbox,
  InputRadio,
  InputToggle,
  Notifications,
  Text,
  Tooltip,
  Selectors,
  InputField,
  ActionButton,
  Spinner,
  Icon,
  Button,
} from "@jds/core";
import useApiHttp from "../hooks/use-http";
import {
  baseToImg,
  bytesToGB,
  isoToInformalData,
  removeUnderscore,
} from "../util/helper";
import {
  Box,
  Card,
  FormControlLabel,
  IconButton,
  Paper,
  Stack,
  Switch,
} from "@mui/material";
import JdsModal from "../components/UI/JdsModal";
import "./SettingsPage.css";
import useInput from "../hooks/use-input";
import { validateNumberInput } from "../util/validation";
import PageLoader from "../components/UI/Loader/PageLoader";
import { updateStorageDetails } from "../store/state-slices/storageDetails";

export default function MembershipPage() {
  const storageDetails = useSelector(
    (state) => state.storageDetails.storageDetails
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { sendRequest: getStorage, isLoading: isStorageGetting } = useApiHttp();

  useEffect(() => {
    // getStorage(
    //   {
    //     // url: `get-storage-details`,
    //     url: `storage/user`,
    //     method: "GET",
    //     base: "MEDIA",
    //   },
    //   null,
    //   (data) => {
    //     // setStorageDetails({
    //     //   ...data?.data,
    //     //   sizeInGb: usedStorage.toFixed(2),
    //     //   totalStorageSizeInGb: totalStorage,
    //     // });
    //     const usedStorage = bytesToGB(data?.data?.usedStorageSizeInBytes);
    //     const totalStorage = bytesToGB(data?.data?.totalStorageSizeInBytes);
    //     dispatch(
    //       updateStorageDetails({
    //         storageDetails: {
    //           ...data?.data,
    //           sizeInGb: usedStorage.toFixed(2),
    //           totalStorageSizeInGb: totalStorage,
    //         },
    //       })
    //     );
    //   },
    //   (err, data) => {
    //     console.log("err==>" + data);
    //   }
    // );
  }, []);
  return (
    <>
      <Container direction="column" gap={16}>
        <Text text="Membership" appearance="heading-xs" />
        <Text text="Plan Details" appearance="body-m" color="primary-grey-80" />
      </Container>
      <Container fullWidth style={{ marginTop: "24px" }}>
        <Box
          sx={{
            width: "100%",
            border: "1px solid var(--color-primary-grey-40)",
            textAlign: "center",
            padding: "24px 8px",
            // backgroundColor: "var(--color-primary-grey-20)",
            borderRadius: "16px",
            // height: "304px",
            boxShadow:
              "0 4px 8px 0 rgba(0, 0, 0, 0.05), 0 6px 20px 0 rgba(0, 0, 0, 0.05)",
          }}
        >
          <Container
            fullWidth
            direction="column"
            gap={8}
            style={{
              borderBottom: "1px solid var(--color-primary-grey-40)",
              padding: "10px",
            }}
          >
            {/* <Text text="Standard plan" appearance="heading-xxs" /> */}
            <Text text={storageDetails?.planType} appearance="body-m-bold" />
            {/* <Text
              text="1080p video resolution, ad-free watching and more."
              appearance="body-xs"
              color="primary-grey-80"
            /> */}
            <Text
              text={
                storageDetails?.activationDate &&
                new Date(storageDetails?.activationDate.slice(0, 10))
                  .toUTCString()
                  .slice(5, 16)
              }
              appearance="body-xs"
              color="primary-grey-80"
            />
          </Container>
          {/* <Container
            gap={48}
            horizontalAlign="space-between"
            verticalAlign="center"
            fullWidth
            style={{
              borderBottom: "1px solid var(--color-primary-grey-40)",
              padding: "10px",
            }}
          >
            <Text text="Change Plan" appearance="body-m-bold" />
            <IconButton>
              <Icon ic={"IcNext"} />
            </IconButton>
          </Container> */}
        </Box>
      </Container>
      <Container gap={16} style={{ marginTop: "24px" }}>
        <Text text="Payment Info" color="primary-grey-80" appearance="body-m" />
      </Container>
      <Container fullWidth direction="column" style={{ marginTop: "24px" }}>
        <Box
          sx={{
            width: "100%",
            border: "1px solid var(--color-primary-grey-40)",
            textAlign: "center",
            padding: "24px 8px",
            // backgroundColor: "var(--color-primary-grey-20)",
            borderRadius: "16px",
            // height: "304px",
            boxShadow:
              "0 4px 8px 0 rgba(0, 0, 0, 0.05), 0 6px 20px 0 rgba(0, 0, 0, 0.05)",
          }}
        >
          <Container
            fullWidth
            direction="column"
            style={{
              borderBottom: "1px solid var(--color-primary-grey-40)",
              padding: "10px",
            }}
          >
            <Text text="Next payment" appearance="body-m-bold" />
            <Text
              text={
                storageDetails?.expiryDate &&
                new Date(storageDetails?.expiryDate.slice(0, 10))
                  .toUTCString()
                  .slice(5, 16)
              }
              color="primary-grey-80"
            />
            {/* <Text text="4561 6544 5465" /> */}
          </Container>
          {/* <div className="nav__link">
            <Container
              verticalAlign="center"
              horizontalAlign="space-between"
              fullWidth
              style={{
                borderBottom: "1px solid var(--color-primary-grey-40)",
                padding: "10px",
              }}
            >
              <Text text="Manage Payment method" appearance="body-m-bold" />
              <IconButton>
                <Icon ic={"IcNext"} />
              </IconButton>
            </Container>
          </div> */}
          <div
            className="nav__link"
            onClick={() => navigate(`/userdetail/order-history`)}
          >
            <Container
              verticalAlign="center"
              horizontalAlign="space-between"
              fullWidth
              style={{
                borderBottom: "1px solid var(--color-primary-grey-40)",
                padding: "10px",
              }}
            >
              <Text text="View Payment History" appearance="body-m-bold" />
              <IconButton>
                <Icon ic={"IcNext"} />
              </IconButton>
            </Container>
          </div>
        </Box>
        {/* <Container style={{ marginTop: "24px" }} fullWidth>
          <Button
            label="Cancel Membership"
            kind="secondary"
            fullWidth
            state="destructive"
          />
        </Container> */}
      </Container>
      <PageLoader open={isStorageGetting} />
    </>
  );
}
